import { cn } from "@/lib/utils"
import { useCountUp } from "@/lib/hooks/use-count-up"
import type { CommunityUser } from "@/lib/community/types"
import "./profile-page.less"

interface ProfileStatsSectionProps {
  stats: CommunityUser["stats"]
  onOpenFollowers?: () => void
  onOpenFollowing?: () => void
}

function BigStat({
  value,
  label,
  delay,
  accent = false,
  onClick,
}: {
  value: number
  label: string
  delay: number
  accent?: boolean
  onClick?: () => void
}) {
  const { formattedCount, countRef } = useCountUp({
    end: value,
    duration: 2500,
    delay,
  })

  const isClickable = !!onClick

  return (
    <div
      className={cn("group relative", isClickable && "cursor-pointer")}
      onClick={onClick}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onKeyDown={isClickable ? (e) => { if (e.key === "Enter" || e.key === " ") onClick?.() } : undefined}
    >
      <p
        ref={countRef}
        className={cn(
          "profile-stat-number transition-all duration-300",
          accent ? "profile-stat-number--accent" : "profile-stat-number--default",
          "group-hover:scale-105",
        )}
      >
        {formattedCount}
      </p>
      <p className={cn("mt-2 profile-stat-label", isClickable && "group-hover:text-foreground transition-colors")}>
        {label}
      </p>
    </div>
  )
}

export function ProfileStatsSection({ stats, onOpenFollowers, onOpenFollowing }: ProfileStatsSectionProps) {
  return (
    <section className="profile-section">
      <div>
        <div className="profile-stats-row">
          <div className="profile-stats-row__numbers">
            <BigStat value={stats.totalLikes} label="获赞" delay={0} accent />
            <BigStat value={stats.posts} label="已发布" delay={200} />
            <BigStat value={stats.followers} label="粉丝" delay={400} accent onClick={onOpenFollowers} />
            <BigStat value={stats.following} label="关注中" delay={600} onClick={onOpenFollowing} />
          </div>
        </div>
      </div>
    </section>
  )
}
